import React, {
  useState,
  useReducer,
  useRef,
  useEffect,
  useContext,
  useMemo,
} from 'react';
import _ from 'lodash';
import { getProductsImages, getPreloadingImagesEnable } from '../selectors';
import { bigImageForDetail, imageUrlForList } from '../utils/products';
import AppContext from '../AppContext';

const FINISH_LOADING_BIG_IMAGES = 'FINISH_LOADING_BIG_IMAGES';
const FINISH_LOADING_SMALL_IMAGES = 'FINISH_LOADING_SMALL_IMAGES';
const INITIAL = 'INITIAL';

function reducer(state, action) {
  switch (action.type) {
    case FINISH_LOADING_BIG_IMAGES:
      return { ...state, loadingBigImages: true };
    case FINISH_LOADING_SMALL_IMAGES:
      return { ...state, loadingSmallImages: true };
    case INITIAL:
      return { loadingSmallImages: false, loadingBigImages: false };
    default:
      return state;
  }
}

const hasFetched = (state, oldState) => state.loadingBigImages
  && state.loadingSmallImages
  && (!oldState.loadingSmallImages || !oldState.loadingBigImages);

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const ProductsImagesPreload = () => {
  const [bigImageIndex, setBigimageIndex] = useState(0);
  const [smallImageIndex, setSmallImageIndex] = useState(0);
  const context = useContext(AppContext);
  const [state, dispatch] = useReducer(reducer, {});
  const oldState = usePrevious(state);

  const images = useMemo(() => getProductsImages(context), [context]);

  const preloadingImagesEnable = getPreloadingImagesEnable(context);

  if (hasFetched(state, oldState)) {
    context.actions.enablePreloadingImages(false);
  }

  if (!_.size(images) || !preloadingImagesEnable) return null;

  const onLoadBigImage = () => {
    if (bigImageIndex < images.length - 1) {
      setBigimageIndex(bigImageIndex + 1);
    } else {
      dispatch({ type: FINISH_LOADING_BIG_IMAGES });
    }
  };

  const onLoadSmallImage = () => {
    if (smallImageIndex < images.length - 1) {
      setSmallImageIndex(smallImageIndex + 1);
    } else {
      dispatch({ type: FINISH_LOADING_SMALL_IMAGES });
    }
  };

  return (
    <div style={{ display: 'block' }}>
      <link
        onLoad={onLoadBigImage}
        onError={onLoadBigImage}
        rel="preload"
        href={imageUrlForList(images[bigImageIndex])}
        as="image"
      />
      <link
        onLoad={onLoadSmallImage}
        onError={onLoadSmallImage}
        rel="preload"
        href={bigImageForDetail(images[smallImageIndex])}
        as="image"
      />
    </div>
  );
};

export default ProductsImagesPreload;
